import { ReactComponent as IconChevronDown } from '@/assets/svgs/chevron-down.svg'
import { ReactComponent as IconEclip } from '@/assets/svgs/eclip-large.svg'
import { ReactComponent as IconGridView } from '@/assets/svgs/grid-view.svg'
import { ReactComponent as IconSearch } from '@/assets/svgs/icon-search.svg'
import { ReactComponent as IconTableView } from '@/assets/svgs/table-view.svg'
import Breadcrumbs from '@/components/Breadcrumbs/index.js'
import Dropdown from '@/components/Dropdown/index.js'
import InputSuffixIcon from '@/components/InputSuffixIcon'
import Portal from '@/components/Portal/index.js'
import { sortByOptions, statusOptions } from '@/constants/index'
import useConfig from '@/hooks/use-config/index.js'
import useEclips from '@/hooks/use-eclips/index'
import useFolders from '@/hooks/use-folder/index.js'
import usePage from '@/hooks/use-page/index.js'
import usePaginating from '@/hooks/use-paginating/index.js'
import { NavLink, useParams } from '@/lib/router-dom/index'
import api from '@/services/api/eclips.js'
import rem from '@/utils/rem.js'
import { orderBy, uniqBy } from 'lodash'
import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import EclipCard from './eclip-card.jsx'
import EclipDataTable from './eclip-data-table.jsx'
import FilterDropDown from './eclip-filter-dropdown.jsx'
import Search from '@/componentsDS/Search/index';
import { feature, features } from "@/utils/feature-verifier";

export default function Eclips() {
	const { provideItems, consumeItems, consumeSystems, provideSystems } = useConfig()
	const [isTableView, setIsTableView] = useState(false)
	const { get: getFolder, currentItem: folder } = useFolders()
	const { eclips, getAll: getAllEclips, loading: eclipLoading, eclipsMeta, setLoading } = useEclips()
	const { breadcrumbsItems, setBreadcrumbsItems } = usePage({
		title: folder?.name,
		breadcrumbs: ['Eclip Bundling'],
	})

	const pageLimit = 5;
	// const params = useParams()
	const {type, folderId} = useParams()

	const [refIdSearch, setRefIdSearch] = useState('')
	const [dataElementId, setDataElementId] = useState({})
	const [recipient, setRecipientOption] = useState({})
	const [recipients, setRecipients] = useState([])
	const [badge, setBadgeOption] = useState({})
	const [fromDate, setFromDate] = useState(null)
	const [endDate, setEndDate] = useState(null)
	const [caseOwner, setCaseOwner] = useState('')
	const [tags, setTags] = useState([])

	const {
		itemsPerPage: itemsPerPageEclips,
		currentPage: currentEclipsPage,
		goToPrev: goToPrevEclips,
		goToNext: goToNextEclips,
		handleCurrnetInput: handleCurrnetInputEclips,
		pageLabel: pageLabelEclips,
		sortConfig: sortConfigEclips,
		setSortConfig: setSortConfigEclips,
	} = usePaginating(
		pageLimit,
		eclipsMeta?.total,
		eclipsMeta?.totalPages,
	)

	const handleFolderEclipClearFilter = () => {
		setRefIdSearch('')
		setDataElementId({})
		setRecipientOption({})
		setBadgeOption({})
		setFromDate(null)
		setEndDate(null)
		setCaseOwner('')
		setTags(tags.map(tag => ({ ...tag, active: false })))
	}

	const enableClear =
		recipient?.id || dataElementId?.id || refIdSearch?.length > 0 || fromDate || endDate || caseOwner?.email?.length > 0 || badge?.label || tags?.some(tag => tag.active)

	function sortArray(array) {
		return orderBy(array, [(option) => option?.name.toLowerCase(), ['asc']])
	}

	useEffect(() => {

		const provideOptions = provideSystems.map((item) => ({
			id: item.id,
			name: item.name,
		}))

		const consumeOptions = consumeSystems.map((item) => ({
			id: item.id,
			name: item.name,
		}))

		const combineOptions = [...consumeOptions, ...provideOptions]
		const updatedOptions = uniqBy(combineOptions, 'id')

		setRecipients(sortArray(updatedOptions))
	}, [consumeSystems, provideSystems])

	const tagFilter = tags?.filter(tag => tag?.active)?.map(tag => tag.id)?.join(',') || undefined;

	const init = () => {
		getAllEclips({
			type: type,
			folder_id: folderId,
			sort_by: sortConfigEclips.key,
			sort_order: sortConfigEclips.direction ? 'ASC' : 'DESC',
			data_element_ids: dataElementId?.id || undefined,
			org_ids: recipient?.id || undefined,
			reference_number: refIdSearch || undefined,
			status: badge?.key || undefined,
			limit: itemsPerPageEclips,
			page: currentEclipsPage,
			from_date: fromDate ? fromDate.toISOString() : undefined,
			to_date: endDate ? endDate.toISOString(): undefined,
			send_owner: type === 'RECEIVE' ? undefined : caseOwner?.email || undefined,
			receive_owner: type === 'RECEIVE' ? caseOwner?.email || undefined : undefined, // TODO
			tag_ids: tagFilter,
		})
		setIsTableView(localStorage.getItem('isTableView') === 'true')
	}

	useEffect(() => {
		getFolder(folderId, {
			type: type,
		})
	}, [folderId])

	const title = type === 'SEND' ? 'My Packages' : 'Shared with me'

	useEffect(() => {
		setBreadcrumbsItems(['Package Sharing', title, folder?.name])
	}, [folder?.name])

	useEffect(()=>{
		api.getTags().then((response) => {
			setTags(response.data?.data);
		});
	},[])

	useEffect(init, [
		sortConfigEclips.direction,
		folderId,
		type,
		dataElementId?.id,
		recipient?.id,
		refIdSearch,
		badge,
		tagFilter,
		currentEclipsPage,
		fromDate, endDate, caseOwner
	])

	return (
		<>
			<div className="eclip-landing__filter">
				<div hidden onClick={init} id="reload-eclips"></div>
				<div className="eclip-filter">
					<div className="search-data-input">
						<div style={{width:"350px"}}>
							<Search
								value={refIdSearch}
								placeholder="Search by Reference ID"
								onChange={(e) => setRefIdSearch(e?.target.value)}
								onCancel={() => setRefIdSearch('')}
							/>
						</div>

						<Dropdown
							placeholder="Find by Data Element"
							value={dataElementId.name}
							filterVisible
							style={{ width: rem(190), zIndex: 1 }}
						>
							{(type === "RECEIVE"
								? consumeItems
								: provideItems
							)?.map((option, index) => {
								return (
									<Dropdown.Item key={index}
										id={option.name}
										onClick={() => {
											if (
												option.name ===
												dataElementId.name
											) {
												setDataElementId({});
											} else {
												setDataElementId(option);
											}
										}}
									>
										{option.name}
									</Dropdown.Item>
								);
							})}
						</Dropdown>

						<Dropdown
							placeholder={
								type === "RECEIVE"
									? "Find by Sender"
									: "Find by Recipient"
							}
							value={recipient.name}
							filterVisible
							style={{ width: rem(190), zIndex: 1 }}
						>
							{recipients.map((option, index) => {
								return (
									<Dropdown.Item key={index}
										id={option.name}
										onClick={() => {
											if (
												option.name === recipient.name
											) {
												setRecipientOption({});
											} else {
												setRecipientOption(option);
											}
										}}
									>
										{option.name}
									</Dropdown.Item>
								);
							})}
						</Dropdown>
						<Dropdown
							placeholder="Status"
							value={badge.label}
							style={{ width: rem(130), zIndex: 1 }}
						>
							{statusOptions.map((option, index) => {
								return (
									<Dropdown.Item key={index}
										id={option.label}
										onClick={() => setBadgeOption(option)}
									>
										{option.label}
									</Dropdown.Item>
								);
							})}
						</Dropdown>
						<FilterDropDown
							active={enableClear}
							fromDate={fromDate}
							endDate={endDate}
							setFromDate={setFromDate}
							setEndDate={setEndDate}
							caseOwner={caseOwner}
							setCaseOwner={setCaseOwner}
							tags={tags}
							setTags={setTags}
						/>
						{enableClear && (
							<div
								onClick={handleFolderEclipClearFilter}
								className="cone-filter-reset"
							>
								Reset
							</div>
						)}
					</div>
					<div className="eclip-landing__view-switch">
						{!isTableView && (
							<div className="search-data-input__sort-by">
								<span className="sort-by">Sort By</span>
								<Dropdown
									value={
										sortByOptions.find(
											(option) =>
												option.direction ===
												sortConfigEclips.direction
										)?.name
									}
									placeholder="Sort By"
									style={{ width: rem(130), zIndex: 1 }}
								>
									{sortByOptions.map((option, index) => {
										return (
											<Dropdown.Item key={index}
												id={option.key}
												onClick={() =>
													setSortConfigEclips({
														key: option.key,
														direction:
															option.direction,
													})
												}
											>
												{option.name}
											</Dropdown.Item>
										);
									})}
								</Dropdown>
							</div>
						)}
						<div
							onClick={() => {
								setIsTableView(true);
								localStorage.setItem("isTableView", "true");
							}}
							className={isTableView ? "active" : ""}
						>
							<IconTableView />
						</div>
						<div
							onClick={() => {
								setIsTableView(false);
								localStorage.setItem("isTableView", "false");
							}}
							className={isTableView ? "" : "active"}
						>
							<IconGridView />
						</div>
					</div>
				</div>
			</div>
			<div className="eclip-landing__breadcrumb">
				<NavLink
					className="link"
					to={`${
						type === "SEND" ? "/eclip" : "/eclip/shared"
					}`}
				>
					{title}
				</NavLink>
				<span className="separator">{">"}</span>
				<div className="current">{folder?.name}</div>
			</div>
			<div>
				<div className="eclip-landing__sub-heading">
					Eclips ({eclipsMeta?.total || 0})
				</div>
				{isTableView ? (
					<EclipDataTable
						items={eclips}
						pageLimit={pageLimit}
						goToPrev={goToPrevEclips}
						goToNext={goToNextEclips}
						currentPage={currentEclipsPage}
						sortConfig={sortConfigEclips}
						setLoading={setLoading}
						setSortConfig={setSortConfigEclips}
						meta={eclipsMeta}
						handleCurrnetInput={handleCurrnetInputEclips}
					/>
				) : (
					<div>
						<div >
							{eclipsMeta?.total ? (
								<div className="eclip-landing__pagination">
									<div className="data-table__table__footer__row">
										<div className="data-table__table__footer__row__left">
											<div className="data-table__table__meta">
												Showing {pageLabelEclips} of{" "}
												{eclipsMeta?.total || 0} entries
											</div>
										</div>
										<div className="data-table__table__footer__row__right">
											<div className="data-table__table__pagination">
												<input
													className="data-table__table__pagination__page"
													type="number"
													value={currentEclipsPage}
													onChange={(e) =>
														handleCurrnetInputEclips(
															e
														)
													}
													min="1"
												/>
												<span className="data-table__table__pagination__page__meta">
													{" "}
													of{" "}
													{eclipsMeta?.totalPages ||
														1}{" "}
													pages{" "}
												</span>
												<button
													className="data-table__table__pagination__prev"
													onClick={() =>
														goToPrevEclips()
													}
													disabled={
														currentEclipsPage ===
															1 ||
														!eclipsMeta?.totalPages
													}
												>
													<IconChevronDown />
												</button>
												<button
													className="data-table__table__pagination__next"
													onClick={() =>
														goToNextEclips()
													}
													disabled={
														currentEclipsPage ===
															eclipsMeta?.totalPages ||
														!eclipsMeta?.totalPages
													}
												>
													<IconChevronDown />
												</button>
											</div>
										</div>
									</div>
								</div>
							) : (
								<div></div>
							)}
							{eclips?.length > 0 ? (
								<div className="eclip-landing-folder--wrapper">
									{eclips?.map((item, index) => {
										return (
											<EclipCard
												key={index}
												item={item}
											/>
										);
									})}
								</div>
							) : (
								<div className="data-table__table__body">
									<div className="data-table__empty">
										<div className="data-table__empty__icon">
											<IconEclip />
											You haven’t created any Eclips,
										</div>
									</div>
								</div>
							)}
						</div>
					</div>
				)}
			</div>
			{eclipLoading &&
				ReactDOM.createPortal(
					<div className="modal white">
						<div className="loading">
							<img src="/loading.gif" />
						</div>
					</div>,
					document.body
				)
			}
		</>
	);
}
